const ENV = process.env.REACT_APP_BACKEND_URL;

// Gleiche Deployment-Instanz bedient /api auf jeder Domain – auf einer eigenen Domain daher same-origin bleiben (Cookies, keine Fremd-URL).
export const BACKEND = (() => {
  try {
    return new URL(ENV).host === window.location.host ? ENV : window.location.origin;
  } catch {
    return ENV;
  }
})();
